import * as React from 'react';

import {formatTimestampForScheduledMailHeader} from 'nutshell-core/date-time/formatting';

import {Avatar} from 'shells/avatar/avatar';

import styles from './avatar-scheduled-time.module.css';

type Props = {
    avatarUrl?: string;
    initials?: string;
    scheduledTime: number | null | undefined;
};

export const AvatarScheduledTime = (props: Props) => {
    const {avatarUrl, initials, scheduledTime} = props;

    // @ts-expect-error
    const getFormattedDate = (time) => {
        const date = formatTimestampForScheduledMailHeader(time);

        // if scheduled today, return 'Sending at [time]'
        // @ts-expect-error
        if (!isNaN(date.charAt(0))) {
            return `Sending at ${date}`;
        }

        // if scheduled tomorrow, return 'Sending tomorrow'
        if (date === 'Tomorrow') {
            return 'Sending tomorrow';
        }

        const month = date.slice(0, 4);
        const uppercaseMonth = month.toUpperCase();
        const formattedDate = date.replace(month, uppercaseMonth);

        // else return 'Sending on [date]'
        return `Sending on ${formattedDate}`;
    };

    return (
        <div className={styles['avatar-time-container']}>
            <div>
                <Avatar type='users' size={32} avatarUrl={avatarUrl} initials={initials} />
            </div>
            {scheduledTime ? (
                <div className={styles['date-container']}>{getFormattedDate(scheduledTime)}</div>
            ) : null}
        </div>
    );
};
